/**
 * @generated SignedSource<<9fe8b9ed466a247ef62028aa813d6f0e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
    readonly showMakeOffer: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_displayInfo";
};
export type PdpRespMarketplaceStickyHeader_displayInfo$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showMakeOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "753af9c9779635a406da5b45f0e1916b";

export default node;
